import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setRateDigitisationMasterData } from 'src/actions/rateMasterActions';
import Loader from 'src/components/common/Loader';

const withRateDigitisationMasterData = (Component) => {
  // tslint:disable-next-line: max-line-length
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    class InitRateDigitisationMaster extends React.Component<any, any> {
      state: any = {
        isLoading: true,
      };

      // conpone
      async componentDidMount() {
        if (!this.props.rateMasterData?.length) {
          await this.props.setRateDigitisationMasterData();
        }
        this.setState({
          isLoading: false,
        });
      }

      render() {
        const { isLoading } = this.state;
        if (isLoading) {
          return <Loader />;
        }
        return <Component {...this.props} />;
      }
    }
  );
};
const mapStateToProps = ({ rateMasterReducer }, ownProps) => ({
  rateMasterData: rateMasterReducer.ratesMasterData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setRateDigitisationMasterData,
    },
    dispatch
  );

export default withRateDigitisationMasterData;
